/**
 * Whether the viewer has asked for less movement.
 *
 * The optional call is load-bearing: jsdom does not implement `matchMedia`, and
 * a missing one should mean "animate normally", not a thrown render.
 */
export function prefersReducedMotion() {
  return (
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
  );
}
